import {
	resolveIdentifier,
	types,
	IAnyModelType,
	IAnyStateTreeNode,
	resolvePath,
	IReferenceType,
} from 'mobx-state-tree';

// @ts-ignore-next-line
import store from 'store';

export function targetReference<IT extends IAnyModelType>(type: IT, target: IAnyStateTreeNode) {
	console.error('Deprecated: targetReference is deprecated. Use storeReference instead');
	return types.reference(type, {
		get(identifier) {
			return resolveIdentifier(type, target, identifier);
		},
		set(value) {
			return value.id;
		},
	});
}

export function storeReference<IT extends IAnyModelType>(
	type: IT,
	path?: string,
): any { // IReferenceType<IT>
	// @TODO: getEnv(self)
	return types.reference(type, {
		get(identifier) {
			return resolveIdentifier(type, path ? resolvePath(store, path) : store, identifier);
		},
		set(value) {
			return value.id;
		},
	});
}
